import React, { useEffect, useState } from "react";
import {
  Box,
  Checkbox,
  FormControlLabel,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { invoicePermissionsService } from "../../services/invoicePermissionsService";

export default function NetInvoicePermissionsCheckbox({
  userId,
  disabled = false,
  onPermissionChange = null,
  isPermissionGranted = false,
}) {
  const { t } = useTranslation();
  const [isChecked, setIsChecked] = useState(isPermissionGranted);
  const [, setLoadingPermissions] = useState(false);

  useEffect(() => {
    setIsChecked(isPermissionGranted);
  }, [isPermissionGranted]);

  const handleChange = (event) => {
    setIsChecked(event.target.checked);
    if (onPermissionChange) {
      onPermissionChange(event.target.checked);
    }
  };

  useEffect(() => {
    if (userId) {
      fetchUserPermissions();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  const fetchUserPermissions = async () => {
    if (!userId) return;
    
    setLoadingPermissions(true);
    try {
      const response = await invoicePermissionsService.getUserPermissions(userId, "net");
      if (response.success && response.permissions) {
        const granted = response.permissions.some(
          (p) => p?.net_invoice_permission === 1
        );
        setIsChecked(granted);
        if (onPermissionChange) onPermissionChange(granted);
      }
    } catch (error) {
      console.error("Error fetching permissions:", error);
    } finally {
      setLoadingPermissions(false);
    }
  };

  if (!userId && !isChecked) {
    return (
      <Box sx={{ mt: 2, p: 2, border: "1px solid #e0e0e0", borderRadius: 1 }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={isChecked}
              onChange={handleChange}
              disabled={disabled}
            />
          }
          label={t("netInvoicePermissions")}
          disabled={disabled}
          sx={{
            display: "block",
            opacity: 1,
          }}
        />
      </Box>
    );
  }

  if (!userId) {
    return (
      <Typography sx={{ py: 2, textAlign: "center", color: "gray" }}>
        {t("saveUserFirst") || "Save user first to manage net invoice permissions"}
      </Typography>
    );
  }

  return (
    <Box sx={{ mt: 2, p: 2, border: "1px solid #e0e0e0", borderRadius: 1 }}>
      <FormControlLabel
        control={
          <Checkbox
            checked={isChecked}
            onChange={handleChange}
            disabled={disabled}
          />
        }
        label={t("netInvoicePermissions")}
        disabled={disabled}
        sx={{
          display: "block",
          opacity: 1,
          mb: 2,
        }}
      />
    </Box>
  );
}
